import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import PayLookupForm from './PayLookupForm';
import * as payActions from '../../actions/payActions';
import * as payPeriodActions from '../../actions/payPeriodActions';
import * as userActions from '../../actions/userActions';
import {
  payPeriodsToSelectOptions,
  usersToSelectOptions,
} from '../../utils/selectDataFormatters';
import moment from 'moment/moment';

class ManagePayPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: {},
      selectedPeriod: {},
      errors: {},
      submitting: false,
    };
  }

  componentWillMount() {
    this.props.actions.loadUsers();
    this.props.actions.loadPayPeriods();
  }

  formIsValid() {
    const { selectedEmployee, selectedPeriod } = this.state;
    let errors = {};
    let isValid = true;
    if (
      selectedEmployee === null ||
      selectedEmployee === '' ||
      selectedEmployee === {}
    ) {
      errors.employee = 'Please select an employee';
      isValid = false;
    }
    if (
      selectedPeriod === null ||
      selectedPeriod === '' ||
      selectedPeriod === {}
    ) {
      errors.payPeriod = 'Please select a pay period';
      isValid = false;
    }
    this.setState({ errors: errors });
    return isValid;
  }

  handleEmployeeChange = (selectedOption) => {
    this.setState({
      selectedEmployee: selectedOption,
    });
  };

  handlePeriodChange = (selectedOption) => {
    this.setState({
      selectedPeriod: selectedOption,
    });
  };

  clearForm = () => {
    this.setState({
      selectedEmployee: {},
      selectedPeriod: {},
      errors: {},
      submitting: false,
    });
  };

  onSubmit = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    const { selectedEmployee, selectedPeriod } = this.state;
    const fileName = selectedEmployee.label + '_' + selectedPeriod.label;
    this.props.actions
      .generatePayCardByUserAndPeriod(
        selectedEmployee.value,
        selectedPeriod.value,
        fileName + '.xls'
      )
      .then(() => {
        this.clearForm();
      });
  };

  render() {
    const { selectedEmployee, selectedPeriod, submitting, errors } = this.state;
    const { users, periods } = this.props;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center mt-4">Employee Pay</h1>
            </Col>
          </Row>
        </Container>
        <PayLookupForm
          selectedEmployee={selectedEmployee}
          onEmployeeChange={this.handleEmployeeChange}
          employees={users}
          selectedPeriod={selectedPeriod}
          onPeriodChange={this.handlePeriodChange}
          payPeriods={periods}
          submitting={submitting}
          onSubmit={this.onSubmit}
          errors={errors}
        />
      </div>
    );
  }
}

ManagePayPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const thirtyDaysBack = moment().subtract(30, 'days');
  const thirtyDaysForward = moment().add(15, 'days');
  const filtered = state.payPeriods.filter(
    (p) => moment(p.startDate) > thirtyDaysBack
  );
  const doubleFiltered = filtered.filter(
    (p) => moment(p.endDate) < thirtyDaysForward
  );

  const periods = payPeriodsToSelectOptions(doubleFiltered);
  const users = usersToSelectOptions(state.users);

  return {
    users: users,
    periods: periods,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userActions, ...payPeriodActions, ...payActions },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManagePayPage)
);



// WEBPACK FOOTER //
// ./src/components/pay/ManagePayPage.js